import React from "react";

const ProductCard = ({ product, ...rest }) => {
  const { title, desc, image } = product;
  return (
    <div style={{ cursor: "pointer" }} {...rest}>
      <div className="item">
        <h4>{title}</h4>
        {image && <img src={image} />}
        <p>{desc}</p>
      </div>
    </div>
  );
};

export default ProductCard;
